import { DictionariesByLocale } from '../../MyStichtingOpenHelpers/src'
import { ComponentTranslationProvider, DictionaryProvider } from '../../MyStichtingOpenComponents/src/providers'
import { useContext } from 'react'
import { LocaleContext } from './locale-provider'
import { getLocaleString } from '../helpers/localeHelpers'

interface DictionaryProviderWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    dictionariesByLocale: DictionariesByLocale
}

export const DictionaryProviderWrapper = ({
    dictionariesByLocale,
    children,
}: DictionaryProviderWrapperProps): JSX.Element => {
    const { activeLocale } = useContext(LocaleContext)

    return (
        <DictionaryProvider dictionary={dictionariesByLocale[getLocaleString(activeLocale)]}>
            <ComponentTranslationProvider dictionary={dictionariesByLocale[getLocaleString(activeLocale)]}>
                {children}
            </ComponentTranslationProvider>
        </DictionaryProvider>
    )
}
